export default {
  primary: "#411564", // Purple
  secondary: "#F47920", // Orange
  accent: "#ECECEC", // Gray
  dark: "#424242",
  error: "#ff5252",
  warning: "#F47920"
};
